function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.01,
  fill: "#fff",
  d: "M0 .316h20v20H0z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.333 9.483h-5V2.816c0-.46.373-.833.834-.833h11.666c.46 0 .834.373.834.833v15c0 .46-.373.833-.834.833H4.167a.833.833 0 01-.834-.833v-6.667h5v2.5l4.167-3.333-4.167-3.333v2.5z",
  fill: "#fff"
});

var SvgLastLogin = function SvgLastLogin(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml,%3Csvg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect opacity='0.01' y='0.315918' width='20' height='20' fill='white'/%3E %3Cpath d='M8.33334 9.48267H3.33334V2.816C3.33334 2.35576 3.70644 1.98267 4.16668 1.98267H15.8333C16.2936 1.98267 16.6667 2.35576 16.6667 2.816V17.816C16.6667 18.2762 16.2936 18.6493 15.8333 18.6493H4.16668C3.70644 18.6493 3.33334 18.2762 3.33334 17.816V11.1493H8.33334V13.6493L12.5 10.316L8.33334 6.98267V9.48267V9.48267Z' fill='white'/%3E %3C/svg%3E";
export { SvgLastLogin as ReactComponent };